import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl } from 'react-intl';
import { Button, Modal } from '@salesforce/design-system-react';
import { withSession } from '../../../i18n/containers/AppInit.js';

class RemoveSelectionsButton extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpen: false
    };
  }

  toggleOpen = () => {
    this.setState({ isOpen: !this.state.isOpen });
  };

  handleRemoveSelections(session) {
    return () => {
      this.toggleOpen();
      this.props.actions.removeSelections(this.props.subscriber, {
        cToken: session.cToken
      });
    };
  }

  render() {
    return withSession(session => {
      return (
        <div>
          <Button
            iconCategory="utility"
            iconName="delete"
            variant="icon"
            iconSize="medium"
            iconVariant="border-filled"
            width="xx-small"
            onClick={this.toggleOpen}
          />
          <Modal
            prompt="warning"
            onRequestClose={this.toggleOpen}
            footer={[
              <Button
                key="remove-selections-cancel"
                label=<FormattedMessage id="common.actions.cancel" />
                onClick={this.toggleOpen}
              />,
              <Button
                key="remove-selections-confirm"
                label=<FormattedMessage id="components.ecs.selectionBrowser.jobs.removeSelections.confirm" />
                variant="brand"
                onClick={this.handleRemoveSelections(session)}
              />
            ]}
            isOpen={this.state.isOpen}
          >
            <div className="slds-m-around_medium">
              <FormattedMessage id="components.ecs.selectionBrowser.jobs.removeSelections.confirmation" />
            </div>
          </Modal>
        </div>
      );
    });
  }
}

RemoveSelectionsButton.contextTypes = {
  router: PropTypes.object
};

RemoveSelectionsButton.propTypes = {
  actions: PropTypes.object,
  subscriber: PropTypes.string,
  location: PropTypes.object
};

export default injectIntl(RemoveSelectionsButton);
